import { defineCustomElements } from '@ionic/pwa-elements/loader';

defineCustomElements(window);

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { setupIonicReact, IonSpinner } from '@ionic/react';
import { Provider as RollbarProvider, ErrorBoundary } from '@rollbar/react';
import { Provider as CableProvider } from './cable';
import mixpanel from 'mixpanel-browser';
import { Capacitor } from '@capacitor/core';
import { StatusBar } from "@capacitor/status-bar";

import initStore from './store';
import App from './App';
import { rollbarConfig } from './helpers/rollbar';

mixpanel.init(import.meta.env.VITE_MIXPANEL_KEY || "Disable", {ignore_dnt: true});
mixpanel.register({app_version: import.meta.env.APP_VERSION, isNativePlatform: Capacitor.isNativePlatform()});
if (!import.meta.env.VITE_MIXPANEL_KEY) mixpanel.disable();

setupIonicReact();

if (Capacitor.isNativePlatform()) {
  StatusBar.setOverlaysWebView({overlay:false});
}

const container = document.getElementById('root');
const root = createRoot(container);

const {store, persistor, cable} = initStore();

root.render(
  <React.StrictMode>
    <RollbarProvider config={rollbarConfig}>
      <ErrorBoundary fallbackUI={ErrorPage}>
        <CableProvider value={cable}>
          <Provider store={store}>
            <PersistGate loading={<IonSpinner className="app-loading"/>} persistor={persistor}>
              <App />
            </PersistGate>
          </Provider>
        </CableProvider>
      </ErrorBoundary>
    </RollbarProvider>
  </React.StrictMode>
);

function ErrorPage() {
  return (
    <p className="ion-padding" style={{textAlign: 'center'}}>
      Something went wrong. This error has been logged for review by our dev team.
      <br/>
      <a href="/">Reload</a>
    </p>
  );
}

window.addEventListener('beforeinstallprompt', (e) => {
  window.androidInstallPrompt = e;
});
